import React from "react"
import { BACKEND_APIS } from "@constants"
import { AutocompleteAjaxSeeker, ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"
import { isLoadingModal, selectedTable } from "Pages/Admin/ProvidersSuppliersMapping/@signals"
import useProvidersSuppliersMappingNormalization from "Pages/Admin/ProvidersSuppliersMapping/@hooks/useNormalize"
import { useSignal } from "@preact/signals-react"
import { Box } from "@mui/material"


export default function NormalizeField() {

	const normalizedData = useSignal(null)
	useProvidersSuppliersMappingNormalization(normalizedData.value)

	return <Box sx={{ display: "flex", alignItems: "start", justifyContent: 'start', gap: 1, flexDirection: 'column' }}>
		<AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
			label="Equivalent mapping"
			urlAjax={`${BACKEND_APIS.ADMIN}/normalized/${selectedTable.value}`}
			value={normalizedData.value}
			onChange={e => normalizedData.value = e.target.value}
		/>
		<ButtonLoadingSeeker
			startIcon={<IconSeeker icon="file-pen"/>}
			loading={isLoadingModal.value}
			disabled={!normalizedData.value}
			onClick={() => isLoadingModal.value = true}
		>
			Confirm Mapping
		</ButtonLoadingSeeker>
	</Box>
}